/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppWithdrawalsRouteImport } from './routes/_app.withdrawals'
import { Route as AppWithdrawalLimitsRouteImport } from './routes/_app.withdrawal-limits'
import { Route as AppWebhookDeliveriesRouteImport } from './routes/_app.webhook-deliveries'
import { Route as AppUnmatchedDepositsRouteImport } from './routes/_app.unmatched-deposits'
import { Route as AppTransactionsRouteImport } from './routes/_app.transactions'
import { Route as AppTariffsRouteImport } from './routes/_app.tariffs'
import { Route as AppRefundsRouteImport } from './routes/_app.refunds'
import { Route as AppProfileRouteImport } from './routes/_app.profile'
import { Route as AppPlatformWalletsRouteImport } from './routes/_app.platform-wallets'
import { Route as AppMerchantsRouteImport } from './routes/_app.merchants'
import { Route as AppInvoicesRouteImport } from './routes/_app.invoices'
import { Route as AppHighRiskRouteImport } from './routes/_app.high-risk'
import { Route as AppGasStationRouteImport } from './routes/_app.gas-station'
import { Route as AppFireblocksEventsRouteImport } from './routes/_app.fireblocks-events'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppChannelsRouteImport } from './routes/_app.channels'
import { Route as AppChannelSettlementsRouteImport } from './routes/_app.channel-settlements'
import { Route as AppChannelPaymentsRouteImport } from './routes/_app.channel-payments'
import { Route as AppAssetsRouteImport } from './routes/_app.assets'
import { Route as AppAdminsRouteImport } from './routes/_app.admins'
import { Route as AppAccountsRouteImport } from './routes/_app.accounts'
import { Route as AppTariffsTariffIdRouteImport } from './routes/_app.tariffs_.$tariffId'
import { Route as AppMerchantsMerchantIdRouteImport } from './routes/_app.merchants_.$merchantId'
import { Route as AppInvoicesInvoiceIdRouteImport } from './routes/_app.invoices_.$invoiceId'
import { Route as AppChannelsChannelIdRouteImport } from './routes/_app.channels_.$channelId'
import { Route as AppChannelSettlementsChannelSettlementIdRouteImport } from './routes/_app.channel-settlements_.$channelSettlementId'
import { Route as AppChannelPaymentsChannelPaymentIdRouteImport } from './routes/_app.channel-payments_.$channelPaymentId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppWithdrawalsRoute = AppWithdrawalsRouteImport.update({
  id: '/withdrawals',
  path: '/withdrawals',
  getParentRoute: () => AppRoute,
} as any)
const AppWithdrawalLimitsRoute = AppWithdrawalLimitsRouteImport.update({
  id: '/withdrawal-limits',
  path: '/withdrawal-limits',
  getParentRoute: () => AppRoute,
} as any)
const AppWebhookDeliveriesRoute = AppWebhookDeliveriesRouteImport.update({
  id: '/webhook-deliveries',
  path: '/webhook-deliveries',
  getParentRoute: () => AppRoute,
} as any)
const AppUnmatchedDepositsRoute = AppUnmatchedDepositsRouteImport.update({
  id: '/unmatched-deposits',
  path: '/unmatched-deposits',
  getParentRoute: () => AppRoute,
} as any)
const AppTransactionsRoute = AppTransactionsRouteImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => AppRoute,
} as any)
const AppTariffsRoute = AppTariffsRouteImport.update({
  id: '/tariffs',
  path: '/tariffs',
  getParentRoute: () => AppRoute,
} as any)
const AppRefundsRoute = AppRefundsRouteImport.update({
  id: '/refunds',
  path: '/refunds',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformWalletsRoute = AppPlatformWalletsRouteImport.update({
  id: '/platform-wallets',
  path: '/platform-wallets',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsRoute = AppMerchantsRouteImport.update({
  id: '/merchants',
  path: '/merchants',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesRoute = AppInvoicesRouteImport.update({
  id: '/invoices',
  path: '/invoices',
  getParentRoute: () => AppRoute,
} as any)
const AppHighRiskRoute = AppHighRiskRouteImport.update({
  id: '/high-risk',
  path: '/high-risk',
  getParentRoute: () => AppRoute,
} as any)
const AppGasStationRoute = AppGasStationRouteImport.update({
  id: '/gas-station',
  path: '/gas-station',
  getParentRoute: () => AppRoute,
} as any)
const AppFireblocksEventsRoute = AppFireblocksEventsRouteImport.update({
  id: '/fireblocks-events',
  path: '/fireblocks-events',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppChannelsRoute = AppChannelsRouteImport.update({
  id: '/channels',
  path: '/channels',
  getParentRoute: () => AppRoute,
} as any)
const AppChannelSettlementsRoute = AppChannelSettlementsRouteImport.update({
  id: '/channel-settlements',
  path: '/channel-settlements',
  getParentRoute: () => AppRoute,
} as any)
const AppChannelPaymentsRoute = AppChannelPaymentsRouteImport.update({
  id: '/channel-payments',
  path: '/channel-payments',
  getParentRoute: () => AppRoute,
} as any)
const AppAssetsRoute = AppAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminsRoute = AppAdminsRouteImport.update({
  id: '/admins',
  path: '/admins',
  getParentRoute: () => AppRoute,
} as any)
const AppAccountsRoute = AppAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AppRoute,
} as any)
const AppTariffsTariffIdRoute = AppTariffsTariffIdRouteImport.update({
  id: '/tariffs_/$tariffId',
  path: '/tariffs/$tariffId',
  getParentRoute: () => AppRoute,
} as any)
const AppMerchantsMerchantIdRoute = AppMerchantsMerchantIdRouteImport.update({
  id: '/merchants_/$merchantId',
  path: '/merchants/$merchantId',
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
  id: '/invoices_/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => AppRoute,
} as any)
const AppChannelsChannelIdRoute = AppChannelsChannelIdRouteImport.update({
  id: '/channels_/$channelId',
  path: '/channels/$channelId',
  getParentRoute: () => AppRoute,
} as any)
const AppChannelSettlementsChannelSettlementIdRoute =
  AppChannelSettlementsChannelSettlementIdRouteImport.update({
    id: '/channel-settlements_/$channelSettlementId',
    path: '/channel-settlements/$channelSettlementId',
    getParentRoute: () => AppRoute,
  } as any)
const AppChannelPaymentsChannelPaymentIdRoute =
  AppChannelPaymentsChannelPaymentIdRouteImport.update({
    id: '/channel-payments_/$channelPaymentId',
    path: '/channel-payments/$channelPaymentId',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/accounts': typeof AppAccountsRoute
  '/admins': typeof AppAdminsRoute
  '/assets': typeof AppAssetsRoute
  '/channel-payments': typeof AppChannelPaymentsRoute
  '/channel-settlements': typeof AppChannelSettlementsRoute
  '/channels': typeof AppChannelsRoute
  '/dashboard': typeof AppDashboardRoute
  '/fireblocks-events': typeof AppFireblocksEventsRoute
  '/gas-station': typeof AppGasStationRoute
  '/high-risk': typeof AppHighRiskRoute
  '/invoices': typeof AppInvoicesRoute
  '/merchants': typeof AppMerchantsRoute
  '/platform-wallets': typeof AppPlatformWalletsRoute
  '/profile': typeof AppProfileRoute
  '/refunds': typeof AppRefundsRoute
  '/tariffs': typeof AppTariffsRoute
  '/transactions': typeof AppTransactionsRoute
  '/unmatched-deposits': typeof AppUnmatchedDepositsRoute
  '/webhook-deliveries': typeof AppWebhookDeliveriesRoute
  '/withdrawal-limits': typeof AppWithdrawalLimitsRoute
  '/withdrawals': typeof AppWithdrawalsRoute
  '/channel-payments/$channelPaymentId': typeof AppChannelPaymentsChannelPaymentIdRoute
  '/channel-settlements/$channelSettlementId': typeof AppChannelSettlementsChannelSettlementIdRoute
  '/channels/$channelId': typeof AppChannelsChannelIdRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/merchants/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/tariffs/$tariffId': typeof AppTariffsTariffIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/accounts': typeof AppAccountsRoute
  '/admins': typeof AppAdminsRoute
  '/assets': typeof AppAssetsRoute
  '/channel-payments': typeof AppChannelPaymentsRoute
  '/channel-settlements': typeof AppChannelSettlementsRoute
  '/channels': typeof AppChannelsRoute
  '/dashboard': typeof AppDashboardRoute
  '/fireblocks-events': typeof AppFireblocksEventsRoute
  '/gas-station': typeof AppGasStationRoute
  '/high-risk': typeof AppHighRiskRoute
  '/invoices': typeof AppInvoicesRoute
  '/merchants': typeof AppMerchantsRoute
  '/platform-wallets': typeof AppPlatformWalletsRoute
  '/profile': typeof AppProfileRoute
  '/refunds': typeof AppRefundsRoute
  '/tariffs': typeof AppTariffsRoute
  '/transactions': typeof AppTransactionsRoute
  '/unmatched-deposits': typeof AppUnmatchedDepositsRoute
  '/webhook-deliveries': typeof AppWebhookDeliveriesRoute
  '/withdrawal-limits': typeof AppWithdrawalLimitsRoute
  '/withdrawals': typeof AppWithdrawalsRoute
  '/channel-payments/$channelPaymentId': typeof AppChannelPaymentsChannelPaymentIdRoute
  '/channel-settlements/$channelSettlementId': typeof AppChannelSettlementsChannelSettlementIdRoute
  '/channels/$channelId': typeof AppChannelsChannelIdRoute
  '/invoices/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/merchants/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/tariffs/$tariffId': typeof AppTariffsTariffIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/_app/accounts': typeof AppAccountsRoute
  '/_app/admins': typeof AppAdminsRoute
  '/_app/assets': typeof AppAssetsRoute
  '/_app/channel-payments': typeof AppChannelPaymentsRoute
  '/_app/channel-settlements': typeof AppChannelSettlementsRoute
  '/_app/channels': typeof AppChannelsRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/fireblocks-events': typeof AppFireblocksEventsRoute
  '/_app/gas-station': typeof AppGasStationRoute
  '/_app/high-risk': typeof AppHighRiskRoute
  '/_app/invoices': typeof AppInvoicesRoute
  '/_app/merchants': typeof AppMerchantsRoute
  '/_app/platform-wallets': typeof AppPlatformWalletsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/refunds': typeof AppRefundsRoute
  '/_app/tariffs': typeof AppTariffsRoute
  '/_app/transactions': typeof AppTransactionsRoute
  '/_app/unmatched-deposits': typeof AppUnmatchedDepositsRoute
  '/_app/webhook-deliveries': typeof AppWebhookDeliveriesRoute
  '/_app/withdrawal-limits': typeof AppWithdrawalLimitsRoute
  '/_app/withdrawals': typeof AppWithdrawalsRoute
  '/_app/channel-payments_/$channelPaymentId': typeof AppChannelPaymentsChannelPaymentIdRoute
  '/_app/channel-settlements_/$channelSettlementId': typeof AppChannelSettlementsChannelSettlementIdRoute
  '/_app/channels_/$channelId': typeof AppChannelsChannelIdRoute
  '/_app/invoices_/$invoiceId': typeof AppInvoicesInvoiceIdRoute
  '/_app/merchants_/$merchantId': typeof AppMerchantsMerchantIdRoute
  '/_app/tariffs_/$tariffId': typeof AppTariffsTariffIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/accounts'
    | '/admins'
    | '/assets'
    | '/channel-payments'
    | '/channel-settlements'
    | '/channels'
    | '/dashboard'
    | '/fireblocks-events'
    | '/gas-station'
    | '/high-risk'
    | '/invoices'
    | '/merchants'
    | '/platform-wallets'
    | '/profile'
    | '/refunds'
    | '/tariffs'
    | '/transactions'
    | '/unmatched-deposits'
    | '/webhook-deliveries'
    | '/withdrawal-limits'
    | '/withdrawals'
    | '/channel-payments/$channelPaymentId'
    | '/channel-settlements/$channelSettlementId'
    | '/channels/$channelId'
    | '/invoices/$invoiceId'
    | '/merchants/$merchantId'
    | '/tariffs/$tariffId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/accounts'
    | '/admins'
    | '/assets'
    | '/channel-payments'
    | '/channel-settlements'
    | '/channels'
    | '/dashboard'
    | '/fireblocks-events'
    | '/gas-station'
    | '/high-risk'
    | '/invoices'
    | '/merchants'
    | '/platform-wallets'
    | '/profile'
    | '/refunds'
    | '/tariffs'
    | '/transactions'
    | '/unmatched-deposits'
    | '/webhook-deliveries'
    | '/withdrawal-limits'
    | '/withdrawals'
    | '/channel-payments/$channelPaymentId'
    | '/channel-settlements/$channelSettlementId'
    | '/channels/$channelId'
    | '/invoices/$invoiceId'
    | '/merchants/$merchantId'
    | '/tariffs/$tariffId'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/login'
    | '/_app/accounts'
    | '/_app/admins'
    | '/_app/assets'
    | '/_app/channel-payments'
    | '/_app/channel-settlements'
    | '/_app/channels'
    | '/_app/dashboard'
    | '/_app/fireblocks-events'
    | '/_app/gas-station'
    | '/_app/high-risk'
    | '/_app/invoices'
    | '/_app/merchants'
    | '/_app/platform-wallets'
    | '/_app/profile'
    | '/_app/refunds'
    | '/_app/tariffs'
    | '/_app/transactions'
    | '/_app/unmatched-deposits'
    | '/_app/webhook-deliveries'
    | '/_app/withdrawal-limits'
    | '/_app/withdrawals'
    | '/_app/channel-payments_/$channelPaymentId'
    | '/_app/channel-settlements_/$channelSettlementId'
    | '/_app/channels_/$channelId'
    | '/_app/invoices_/$invoiceId'
    | '/_app/merchants_/$merchantId'
    | '/_app/tariffs_/$tariffId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/withdrawals': {
      id: '/_app/withdrawals'
      path: '/withdrawals'
      fullPath: '/withdrawals'
      preLoaderRoute: typeof AppWithdrawalsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/withdrawal-limits': {
      id: '/_app/withdrawal-limits'
      path: '/withdrawal-limits'
      fullPath: '/withdrawal-limits'
      preLoaderRoute: typeof AppWithdrawalLimitsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/webhook-deliveries': {
      id: '/_app/webhook-deliveries'
      path: '/webhook-deliveries'
      fullPath: '/webhook-deliveries'
      preLoaderRoute: typeof AppWebhookDeliveriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/unmatched-deposits': {
      id: '/_app/unmatched-deposits'
      path: '/unmatched-deposits'
      fullPath: '/unmatched-deposits'
      preLoaderRoute: typeof AppUnmatchedDepositsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/transactions': {
      id: '/_app/transactions'
      path: '/transactions'
      fullPath: '/transactions'
      preLoaderRoute: typeof AppTransactionsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tariffs': {
      id: '/_app/tariffs'
      path: '/tariffs'
      fullPath: '/tariffs'
      preLoaderRoute: typeof AppTariffsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/refunds': {
      id: '/_app/refunds'
      path: '/refunds'
      fullPath: '/refunds'
      preLoaderRoute: typeof AppRefundsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform-wallets': {
      id: '/_app/platform-wallets'
      path: '/platform-wallets'
      fullPath: '/platform-wallets'
      preLoaderRoute: typeof AppPlatformWalletsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants': {
      id: '/_app/merchants'
      path: '/merchants'
      fullPath: '/merchants'
      preLoaderRoute: typeof AppMerchantsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices': {
      id: '/_app/invoices'
      path: '/invoices'
      fullPath: '/invoices'
      preLoaderRoute: typeof AppInvoicesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/high-risk': {
      id: '/_app/high-risk'
      path: '/high-risk'
      fullPath: '/high-risk'
      preLoaderRoute: typeof AppHighRiskRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gas-station': {
      id: '/_app/gas-station'
      path: '/gas-station'
      fullPath: '/gas-station'
      preLoaderRoute: typeof AppGasStationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fireblocks-events': {
      id: '/_app/fireblocks-events'
      path: '/fireblocks-events'
      fullPath: '/fireblocks-events'
      preLoaderRoute: typeof AppFireblocksEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channels': {
      id: '/_app/channels'
      path: '/channels'
      fullPath: '/channels'
      preLoaderRoute: typeof AppChannelsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channel-settlements': {
      id: '/_app/channel-settlements'
      path: '/channel-settlements'
      fullPath: '/channel-settlements'
      preLoaderRoute: typeof AppChannelSettlementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channel-payments': {
      id: '/_app/channel-payments'
      path: '/channel-payments'
      fullPath: '/channel-payments'
      preLoaderRoute: typeof AppChannelPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assets': {
      id: '/_app/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AppAssetsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admins': {
      id: '/_app/admins'
      path: '/admins'
      fullPath: '/admins'
      preLoaderRoute: typeof AppAdminsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/accounts': {
      id: '/_app/accounts'
      path: '/accounts'
      fullPath: '/accounts'
      preLoaderRoute: typeof AppAccountsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tariffs_/$tariffId': {
      id: '/_app/tariffs_/$tariffId'
      path: '/tariffs/$tariffId'
      fullPath: '/tariffs/$tariffId'
      preLoaderRoute: typeof AppTariffsTariffIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/merchants_/$merchantId': {
      id: '/_app/merchants_/$merchantId'
      path: '/merchants/$merchantId'
      fullPath: '/merchants/$merchantId'
      preLoaderRoute: typeof AppMerchantsMerchantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invoices_/$invoiceId': {
      id: '/_app/invoices_/$invoiceId'
      path: '/invoices/$invoiceId'
      fullPath: '/invoices/$invoiceId'
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channels_/$channelId': {
      id: '/_app/channels_/$channelId'
      path: '/channels/$channelId'
      fullPath: '/channels/$channelId'
      preLoaderRoute: typeof AppChannelsChannelIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channel-settlements_/$channelSettlementId': {
      id: '/_app/channel-settlements_/$channelSettlementId'
      path: '/channel-settlements/$channelSettlementId'
      fullPath: '/channel-settlements/$channelSettlementId'
      preLoaderRoute: typeof AppChannelSettlementsChannelSettlementIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/channel-payments_/$channelPaymentId': {
      id: '/_app/channel-payments_/$channelPaymentId'
      path: '/channel-payments/$channelPaymentId'
      fullPath: '/channel-payments/$channelPaymentId'
      preLoaderRoute: typeof AppChannelPaymentsChannelPaymentIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAccountsRoute: typeof AppAccountsRoute
  AppAdminsRoute: typeof AppAdminsRoute
  AppAssetsRoute: typeof AppAssetsRoute
  AppChannelPaymentsRoute: typeof AppChannelPaymentsRoute
  AppChannelSettlementsRoute: typeof AppChannelSettlementsRoute
  AppChannelsRoute: typeof AppChannelsRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppFireblocksEventsRoute: typeof AppFireblocksEventsRoute
  AppGasStationRoute: typeof AppGasStationRoute
  AppHighRiskRoute: typeof AppHighRiskRoute
  AppInvoicesRoute: typeof AppInvoicesRoute
  AppMerchantsRoute: typeof AppMerchantsRoute
  AppPlatformWalletsRoute: typeof AppPlatformWalletsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppRefundsRoute: typeof AppRefundsRoute
  AppTariffsRoute: typeof AppTariffsRoute
  AppTransactionsRoute: typeof AppTransactionsRoute
  AppUnmatchedDepositsRoute: typeof AppUnmatchedDepositsRoute
  AppWebhookDeliveriesRoute: typeof AppWebhookDeliveriesRoute
  AppWithdrawalLimitsRoute: typeof AppWithdrawalLimitsRoute
  AppWithdrawalsRoute: typeof AppWithdrawalsRoute
  AppChannelPaymentsChannelPaymentIdRoute: typeof AppChannelPaymentsChannelPaymentIdRoute
  AppChannelSettlementsChannelSettlementIdRoute: typeof AppChannelSettlementsChannelSettlementIdRoute
  AppChannelsChannelIdRoute: typeof AppChannelsChannelIdRoute
  AppInvoicesInvoiceIdRoute: typeof AppInvoicesInvoiceIdRoute
  AppMerchantsMerchantIdRoute: typeof AppMerchantsMerchantIdRoute
  AppTariffsTariffIdRoute: typeof AppTariffsTariffIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAccountsRoute: AppAccountsRoute,
  AppAdminsRoute: AppAdminsRoute,
  AppAssetsRoute: AppAssetsRoute,
  AppChannelPaymentsRoute: AppChannelPaymentsRoute,
  AppChannelSettlementsRoute: AppChannelSettlementsRoute,
  AppChannelsRoute: AppChannelsRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppFireblocksEventsRoute: AppFireblocksEventsRoute,
  AppGasStationRoute: AppGasStationRoute,
  AppHighRiskRoute: AppHighRiskRoute,
  AppInvoicesRoute: AppInvoicesRoute,
  AppMerchantsRoute: AppMerchantsRoute,
  AppPlatformWalletsRoute: AppPlatformWalletsRoute,
  AppProfileRoute: AppProfileRoute,
  AppRefundsRoute: AppRefundsRoute,
  AppTariffsRoute: AppTariffsRoute,
  AppTransactionsRoute: AppTransactionsRoute,
  AppUnmatchedDepositsRoute: AppUnmatchedDepositsRoute,
  AppWebhookDeliveriesRoute: AppWebhookDeliveriesRoute,
  AppWithdrawalLimitsRoute: AppWithdrawalLimitsRoute,
  AppWithdrawalsRoute: AppWithdrawalsRoute,
  AppChannelPaymentsChannelPaymentIdRoute:
    AppChannelPaymentsChannelPaymentIdRoute,
  AppChannelSettlementsChannelSettlementIdRoute:
    AppChannelSettlementsChannelSettlementIdRoute,
  AppChannelsChannelIdRoute: AppChannelsChannelIdRoute,
  AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,
  AppMerchantsMerchantIdRoute: AppMerchantsMerchantIdRoute,
  AppTariffsTariffIdRoute: AppTariffsTariffIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
